import { useEffect } from 'react';

function ImageViewer({ imageSrc, imageAlt, isOpen, onClose }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="image-viewer-backdrop" onClick={onClose}>
      <button
        className="image-viewer-close"
        onClick={onClose}
        aria-label="Close image viewer"
      >
        ×
      </button>
      <div className="image-viewer-content" onClick={(e) => e.stopPropagation()}>
        <img
          src={imageSrc}
          alt={imageAlt}
          className="image-viewer-image"
        />
      </div>
    </div>
  );
}

export default ImageViewer;
